import {AssemblySearchRequest} from "../ImpellerAssemblyService";

export function convertAssemblyCriteriaToExportFormat(criteria: AssemblySearchRequest): ExportedAssemblyCriteriaV1 {
    return {
        criteriaVersion: 1,
        ...criteria
    };
}

export interface AbstractExportedAssemblyCriteria {
    criteriaVersion: number
}

/**
 * Export format for AssemblySearchRequest criteria
 * Version 1 - initial implementation based on AssemblySearchRequest structure
 * This creates a type snapshot for backward compatibility as clients may have exported files
 * saved locally
 */
export type ExportedAssemblyCriteriaV1 = {
    criteriaVersion: 1, // Version discriminator for future detection/compatibility
    bladeCount: number | null,
    adjustableImpellerId: string | null,
    bladeManufacturing: "standard" | "assg",
    impellerDiameter: number,
    fanMountingPositionName: string,
    auditSeverityName: string,
    shaftDiameter: number | null,
    shaftLength: number | null,
    customShaftThreadPreference: { customScrewM: number, customDlugoscGwintuWCzopieWalu: number } | null,
    expectedImpellerHeight: number | null,
    bladeProfileDisplayName: string | null,
    bladeAngle: number | null,
    betaIncrementation: number | null,
    preferredConstructionMaterialCode: string,
    preferredFastenersMaterialCode: string,
    rpm: number | null,
    bladeEndSpeed: number | null,
    powerAtWorkingPoint: number | null,
    totalPressureAtWorkingPoint: number | null,
    softStartPresent: boolean | null,
    realizeWithClutch: boolean,
    ignoreMaximumTestedClutchManufacturings: boolean | null,
    allowDemoData: boolean | null,
    allowTooLongClutch: boolean | null
}